import { animate, AnimationBuilder, style } from '@angular/animations';
import { ElementRef, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  // Private properties
  private el: ElementRef;
  private stopped: boolean;
  /**
   * Service constructor
   *
   * @param animationBuilder: AnimationBuilder
   */
  constructor(private animationBuilder: AnimationBuilder) { }

  /**
   * Init
   *
   * @param element: ElementRef
   */
  init(element: ElementRef) {
    this.el = element;
  }

  /**
   * Hide
   */
  hide() {
    if (this.stopped || !this.el) {
      return;
    }

    const player = this.animationBuilder
      .build([style({ opacity: '1' }), animate(800, style({ opacity: '0' }))])
      .create(this.el.nativeElement);

    player.onDone(() => {
      this.el.nativeElement.setAttribute('style', 'height: 0px !important; pointer-events: none !important; overflow: hidden !important;');
      this.stopped = true;
    });

    setTimeout(() => player.play(), 100);
  };

  show() {
    const player = this.animationBuilder
      .build([style({ opacity: '1' })])
      .create(this.el.nativeElement);

    player.onDone(() => {
      this.el.nativeElement.setAttribute('style', 'height: 100% !important');
      this.stopped = false;
    });

    player.play();
    this.el.nativeElement.setAttribute('style', 'height: 100% !important');
    this.stopped = false;
    //this.spinnerEvents.next('show');  // emit value
  };

}
